export default __webpack_public_path__ + "static/media/PPI-walkway-007.e6f8f208.jpg";